import React from 'react';
import PropTypes from 'prop-types';
import { FilterChip } from '../FilterChip';
import { useClearRefinements, useCurrentRefinements } from 'react-instantsearch';

export const CurrentFilters = ({
    useButtons,
    buttonClasses = '',
    clearAllClasses = '',
    onClose,
    formatLabel,
}) => {
    const { items: facets, refine } = useCurrentRefinements();
    const { refine: clearAll } = useClearRefinements();

    if (facets.length === 0) {
        return null;
    }

    const filteredFacets = facets.filter(
        f => f.attribute !== 'events_attended' && f.attribute !== 'events_attended.code'
    );

    return (
        <div>
            <div className="mb-1">
                <ul className="list-inline mb-0">
                    {filteredFacets.map(facet => {
                        if (facet.refinements) {
                            return facet.refinements.map(filter => (
                                <FilterChip
                                    key={`${facet.id}-${filter.label}`}
                                    label={formatLabel ? formatLabel(facet.attribute, filter.label) : filter.label}
                                    value={filter.value}
                                    attribute={facet.attribute}
                                    buttonClasses={buttonClasses}
                                    onClick={() => {
                                        refine(filter);
                                    }}
                                />
                            ));
                        }

                        return null;
                    })}
                </ul>
            </div>

            {!useButtons && filteredFacets.length > 0 && (
                <div>
                    <a className={clearAllClasses} style={styles.clearAllButton} onClick={() => clearAll()}>
                        Clear All Filters
                    </a>
                </div>
            )}

            {useButtons && (
                <div style={styles.mobileButtonContainer}>
                    <button
                        type="button"
                        className="btn btn-tertiary mr-2"
                        style={styles.mobileButton}
                        onClick={() => onClose()}
                    >
                        Apply
                    </button>

                    <button
                        type="button"
                        className="btn btn-tertiary ml-2"
                        style={styles.mobileButton}
                        onClick={() => clearAll()}
                    >
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
};

const styles = {
    clearAllButton: {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    mobileButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1rem',
    },
    mobileButton: {
        padding: '0.5rem 1.0rem',
        width: 'auto',
    },
};

CurrentFilters.propTypes = {
    useButtons: PropTypes.bool,
    buttonClasses: PropTypes.string,
    clearAllClasses: PropTypes.string,
    onClose: PropTypes.func,
    formatLabel: PropTypes.func,
};
